import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from 'src/app/common/layouts/basicLayout.component';
import { AuthGuard, PrepareGuard } from 'src/app/core/core.module';
import { TimeOverviewComponent } from './time-overview/time-overview.component';
import { TimePayrollComponent } from './time-payroll/time-payroll.component';
import { TimeEditDialogComponent } from './time-edit-dialog/time-edit-dialog.component';
import { TimeAddDialogComponent } from './time-add-dialog/time-add-dialog.component';


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'time',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'search', pathMatch: 'full' },
                    { path: 'overview', component: TimeOverviewComponent, data: { title: 'Time Overview' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'payroll', component: TimePayrollComponent, data: { title: 'Payroll Review' }, canActivate: [AuthGuard, PrepareGuard] },
                ],
            },
        ]),
    ],
    declarations: [TimeOverviewComponent, TimePayrollComponent, TimeAddDialogComponent, TimeEditDialogComponent]
})
export class TimeModule {}
